(function () {
  if (window.__petesBundleSubscriptionDisplay) return;
  window.__petesBundleSubscriptionDisplay = true;

  const stackedDiscounts = { 6: 25, 8: 28, 12: 30 };

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function percent(reference, price) {
    return reference > price ? Math.round(((reference - price) / reference) * 100) : 0;
  }
  function sizeOf(builder) {
    try {
      const option = JSON.parse(builder.getAttribute('data-options') || '[]')[0] || '';
      return Number(String(option).match(/\d+/)?.[0]) || 4;
    } catch (_) { return 4; }
  }
  function pricesFor(builder) {
    const oneTime = Number(builder.getAttribute('data-onetime-price') || 0);
    const reference = Number(builder.getAttribute('data-price') || 0) || oneTime;
    let plan = null;
    let allocation = null;
    try {
      const groups = JSON.parse(builder.getAttribute('data-selling-plans') || '[]');
      plan = groups[0]?.selling_plans?.[0] || null;
      const allocations = JSON.parse(builder.getAttribute('data-selling-plan-allocations') || '[]');
      allocation = allocations.find(item => String(item.selling_plan_id) === String(plan?.id)) || allocations[0] || null;
    } catch (_) {}
    const adjustment = plan?.price_adjustments?.[0];
    const planPercent = adjustment?.value_type === 'percentage' ? Number(adjustment.value) : 0;
    const first = Number(allocation?.price) || Math.round(oneTime * (1 - planPercent / 100));
    const renewal = Number(allocation?.price_adjustments?.at(-1)?.price) || first;
    return { oneTime, reference, first, renewal, planPercent };
  }
  function setPrice(label, reference, price) {
    if (!label) return;
    const expected = reference > price
      ? '<s><span> ' + money(reference) + '</span></s> <span class="text-primary"><span> ' + money(price) + '</span></span>'
      : '<span> ' + money(price) + '</span>';
    if (label.innerHTML !== expected) label.innerHTML = expected;
  }
  function update(builder) {
    const { oneTime, reference, first, renewal, planPercent } = pricesFor(builder);
    if (!oneTime || !reference) return;
    const size = sizeOf(builder);
    const subscription = builder.querySelector('input[name="subscription-group"][value="true"]');
    const subLabel = subscription?.closest('label')?.parentElement;
    const oneTimeInput = builder.querySelector('input[data-name="loop-one-time-purchase"]');
    const oneTimeLabel = oneTimeInput?.closest('label');
    const discount = size === 4 ? percent(reference, first) : (stackedDiscounts[size] || planPercent);
    const displaySubPrice = size === 4 ? first : Math.round(oneTime * (1 - planPercent / 100));
    const discountLabel = subLabel?.querySelector('.flex-grow .text-primary');
    if (discountLabel && discountLabel.textContent.trim() !== discount + '% Off') discountLabel.textContent = discount + '% Off';
    setPrice(subLabel?.querySelector('.ml-auto.text-right'), reference, displaySubPrice);
    if (size === 4) {
      const oneTimePrice = oneTimeLabel?.querySelector('.ml-auto.text-right');
      if (oneTimePrice) {
        const compare = oneTimePrice.querySelector('s');
        if (compare) compare.hidden = reference <= oneTime;
      }
      builder.querySelectorAll('.variant-label.one-time').forEach(label => {
        if (label.closest('[data-related-id]')?.getAttribute('data-related-id') === '9863374078271') label.hidden = reference <= oneTime;
      });
    }
    const renewalDiscount = size === 4 ? percent(reference, renewal) : discount;
    const walker = document.createTreeWalker(builder, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (/Always\s+\d+%\s+Off/i.test(node.nodeValue)) {
        const next = node.nodeValue.replace(/Always\s+\d+%\s+Off/i, 'Always ' + renewalDiscount + '% Off');
        if (next !== node.nodeValue) node.nodeValue = next;
      }
    }
  }
  function updateAll() { document.querySelectorAll('bundle-builder').forEach(update); }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; updateAll(); });
  }
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('change', schedule);
  document.addEventListener('click', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
